import React, { useState } from 'react';
import { Typography, Button, Avatar as AntdAvatar, Card, Select, DatePicker, Checkbox, Divider } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { BlueArrow } from 'assets';
import { ticketDetailedMessages } from 'messages/ticket-detailed.messages';
import Avatar from 'components/common/avatar/Avatar';
import dayjs from 'dayjs';
import { TicketDetail } from 'types';
import progressIcon from '../../assets/svg/progressing-setting.svg';
import { requestform } from 'messages';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { GetReasonOutageService, GetUserListInOrganization } from '../../hooks/request-form';
import { TicketEventDto } from 'types/dto/ticket';
import { useUser } from 'hooks';

interface RequestDetailProcessingProps {
  requestItem: TicketDetail;
  processingContent: string;
  isHistory: boolean;

  setProcessingContent?: (value: string) => void;
  setAssignUserInUnit?: (value: number) => void;
  setOutageReasonId?: (value: number) => void;
  setDatePowerRestore?: (value: Date) => void;
  setIsPowerRestore?: (value: boolean) => void;
}
//Function
// const EventItem: React.FC<{ event: any; orgName?: string }> = ({ event, orgName }) => (
//   <div className='relative mx-4 flex max-w-4xl items-center justify-between border-l pb-10'>
//     <div className='absolute -left-4 top-[20%] rounded-full border bg-white p-2'>
//       <BlueArrow />
//     </div>
//     <div className='flex w-full items-center justify-between pt-8'>
//       {/*Content*/}
//       <div className='mx-6 w-full'>
//         <Typography.Text className='text-[16px]/[18px] font-semibold text-[#141414]'>
//           {event.createdByName}
//         </Typography.Text>{' '}
//         <Typography.Text>{event?.actionType?.name}</Typography.Text>
//         <br />
//         <div className='text-[14px] italic text-[#141414]'>
//           {formatEventDate(event.createdAt)}
//           {orgName}
//         </div>
//         <div className='mt-4 max-h-[100px] overflow-auto rounded-[5px] border bg-[#F7F8F9] p-4 text-[16px]/[20px] text-[#141414]'>
//           {event.currentContent}
//         </div>
//       </div>

//       {/*Avatar */}
//       <Avatar name={event.createdByName} size={32} />
//     </div>
//   </div>
// );
// const formatEventDate = (date?: string) => {
//   if (!date) return '';
//   const formatted = dayjs(date).format('DD [tháng] MM, YYYY - HH:mm');
//   const [datePart, timePart] = formatted.split('-');
//   return (
//     <>
//       {timePart}
//       <Typography.Text className='relative bottom-1 text-2xl'>.</Typography.Text> {datePart}
//       <Typography.Text className='relative bottom-1 text-2xl'>.</Typography.Text>{' '}
//     </>
//   );
// };

// const parseCurrentContent = (content: string) => {
//     try {
//       const parsed = JSON.parse(content);
//       if (parsed && typeof parsed === 'object' && 'numOfRequests' in parsed) {
//         return `Số lần gọi: ${parsed.numOfRequests}`;
//       }
//     } catch (error) {
//       // Nội dung không phải JSON
//     }
//     return content;
//   };

  const parseCurrentContent = (content: string) => {
      try {
        const parsed = JSON.parse(content);
        if (parsed && typeof parsed === 'object' && 'numOfRequests' in parsed) {
          return `Số lần gọi: ${parsed.numOfRequests}`;
        }
      } catch (error) {
        // Nội dung không phải JSON
      }
      return content;
    };
  
  const EventItem: React.FC<{ event: TicketEventDto; isFirstEvent: boolean }> = ({ event, isFirstEvent }) => {
    const { user: eventUser } = useUser(event.createdBy);
  
    return (
      <div className='flex items-center justify-between py-2 relative'>
        {isFirstEvent && (
          <div className='absolute -left-8 top-1/2 -translate-y-1/2 rounded-full border bg-white p-2'>
            <BlueArrow />
          </div>
        )}
  
        <div className='flex-1 mx-4 w-full'>
          {isFirstEvent && (
            <div className='flex items-center justify-between'>
              <div className='text-[14px] italic text-[#141414]'>
                {dayjs(event.createdAt).format('HH:mm - DD/MM/YYYY')} bởi {event?.createdByName} •{' '}
                {eventUser?.organizationUnit?.name}
              </div>
              <Avatar name={event.createdByName} size={32} />
            </div>
          )}
  
          <Typography.Text className='text-[16px]/[18px] font-semibold text-[#141414]'>
            {event.actionType?.name}
          </Typography.Text>
  
          <div className='mt-2 rounded-[5px] border bg-[#F7F8F9] p-4 text-[16px]/[20px] text-[#141414]'>
            {parseCurrentContent(event.currentContent)}
          </div>
        </div>
  
        
      </div>
    );
  };

// const EventItem: React.FC<{ event: TicketEventDto; isFirstEvent: boolean }> = ({ event, isFirstEvent }) => {
//   const { user: eventUser } = useUser(event.createdBy);

//   return (
//     <div className='flex items-center justify-between py-2 relative'>
//       {isFirstEvent && (
//         <div className='absolute -left-8 top-1/2 -translate-y-1/2 rounded-full border bg-white p-2'>
//           <BlueArrow />
//         </div>
//       )}

//       <div className='flex-1 mx-4 w-full'>
//         {isFirstEvent && (
//           <div className='flex items-center justify-between'>
//             <div className='text-[14px] italic text-[#141414]'>
//               {dayjs(event.createdAt).format('HH:mm - DD/MM/YYYY')} bởi {event?.createdByName} •{' '}
//               {eventUser?.organizationUnit?.name}
//             </div>
//             <Avatar name={event.createdByName} size={32} />
//           </div>
//         )}

//         <Typography.Text className='text-[16px]/[18px] font-semibold text-[#141414]'>
//           {event.actionType?.name}
//         </Typography.Text>

//         <div className='mt-2 rounded-[5px] border bg-[#F7F8F9] p-4 text-[16px]/[20px] text-[#141414]'>
//           {parseCurrentContent(event.currentContent)}
//         </div>
//       </div>

      
//     </div>
//   );
// };

//Main
const NormalTicketOpenProcessing: React.FC<RequestDetailProcessingProps> = ({
  requestItem,
  processingContent,
  isHistory,

  setProcessingContent,
  setAssignUserInUnit,
  setOutageReasonId,
  setDatePowerRestore,
  setIsPowerRestore
}) => {
  const [isShow, setIsShow] = useState(false);
  const location = useLocation().pathname;

  const profile = useSelector((state: RootState) => state.users.userProfile);
  const { userInUnitList } = GetUserListInOrganization(profile?.organizationUnitId ? profile?.organizationUnitId : 0);
  //16: optionTypeId => outage
  const { optionsList, optionsCount, optionLoading } = GetReasonOutageService(16);

  const events = requestItem?.ticketEvents || [];
  const hasMultipleEvents = events.length > 1;

  const handleDatePowerRestoreChange = (value: dayjs.Dayjs) => setDatePowerRestore?.(value.toDate());
  const handlePowerRestoreChange = (checked: boolean) => setIsPowerRestore?.(checked);
  
  // const groupEventsByBatchUuid = (events: any[]) => {
  //   return events.reduce((acc, event) => {
  //     const { batchUuid } = event;
  //     if (!acc[batchUuid]) {
  //       acc[batchUuid] = [];
  //     }
  //     acc[batchUuid].push(event);
  //     return acc;
  //   }, {} as Record<string, any[]>);
  // };
  // const groupedEvents = groupEventsByBatchUuid(events);
  // const [isShowAllEvents, setIsShowAllEvents] = useState(false);
  const isShowAllEvents = true;
    // const toggleShowAll = () => {
    //   setIsShowAllEvents((prev) => !prev);
    // };
    const sortedEvents = [...events].sort((a, b) => dayjs(a.createdAt).valueOf() - dayjs(b.createdAt).valueOf());
    const latestEvent = sortedEvents[sortedEvents.length - 1];
    const remainingEvents = sortedEvents.slice(0, -1);
  const groupEventsByBatchUuid = (events: (TicketEventDto | undefined)[]) => {
        return events.reduce((acc, event) => {
          if (!event || !event.batchUuid) return acc; // ⛔ bỏ qua nếu không hợp lệ
    
          const { batchUuid } = event;
          if (!acc[batchUuid]) {
            acc[batchUuid] = [];
          }
          acc[batchUuid].push(event);
          return acc;
        }, {} as Record<string, TicketEventDto[]>);
      };
    
      const groupedEvents = groupEventsByBatchUuid(
        isShowAllEvents ? sortedEvents : latestEvent ? [latestEvent] : []
      );

  return (
    <Card className='border-none'>
      {requestItem?.serviceType?.code === 'baoMatDien' && requestItem?.status.code !== 'CHOTIEPNHAN' && (
        <div className='space-y-2 pb-5'>
          <div className='flex w-full items-center space-x-6'>
            <div className='w-1/5'>
              <Typography.Text className='text-[16px]/[16px] text-[#6C737E] text-nowrap'>
                {requestform.reasonOutage}
              </Typography.Text>
            </div>
            {requestItem?.status.code !== 'CHOTIEPNHAN' && requestItem?.status?.code !== 'HOANTAT' ? (
              <Select
                loading={optionLoading}
                className='w-full'
                disabled={requestItem?.status?.code === 'HOANTAT' || isHistory}
                defaultValue={
                  requestItem?.additionalInfo?.outageReasonId != null
                    ? optionsList.find((option) => option.optionId === requestItem?.additionalInfo?.outageReasonId)
                        ?.optionId
                    : optionsList[0]?.optionId
                }
                style={{ width: 200 }}
                onChange={(value) => setOutageReasonId && setOutageReasonId(value)}
                options={[
                  ...optionsList.map((option) => ({
                    value: option.optionId,
                    label: option.code + ' ' + option.name
                  }))
                ]}
              />

            ) : (
                <Typography.Text className='text-[16px]/[16px] text-[#000000]'>
                {
                  requestItem?.additionalInfo?.outageReasonId != null
                  ? optionsList.find((option) => option.optionId === requestItem?.additionalInfo?.outageReasonId)
                    ?.name
                  : optionsList[0]?.name
                }
                </Typography.Text>
            )}
          </div>

          <div className='flex w-full items-center space-x-3'>
            <div className='w-1/5'>
              <Typography.Text className='text-[16px]/[16px] text-[#6C737E]'>{requestform.timeOutage}</Typography.Text>
            </div>

            <div className='flex w-full items-center justify-between'>
              <Typography.Text className='text-[16px]/[16px] text-[#000000]'>
                {requestItem?.additionalInfo?.outageAt
                  ? dayjs(requestItem?.additionalInfo?.outageAt).format('DD/MM/YYYY HH:mm')
                  : ''}
              </Typography.Text>

              <div>
                <div className='flex items-center space-x-3'>
                  <Typography.Text className='text-[16px]/[16px] text-[#6C737E]'>
                    {requestform.datePowerRestored}
                  </Typography.Text>
                  {requestItem?.status.code !== 'CHOTIEPNHAN' && requestItem?.status?.code !== 'HOANTAT' ? (
                      <DatePicker
                        value={
                          requestItem?.additionalInfo?.powerRestorationAt
                            ? dayjs(requestItem?.additionalInfo?.powerRestorationAt)
                            : undefined
                        }
                        name='powerRestorationAt'
                        showTime={{ format: 'HH:mm:ss' }}
                        format='DD/MM/YYYY HH:mm:ss'
                        onChange={handleDatePowerRestoreChange}
                        placeholder='Ngày giờ có điện'
                        disabled={requestItem?.status?.code === 'HOANTAT' || isHistory}
                      />

                  ) : (
                    
                      
                      <Typography.Text className='text-[16px]/[16px] text-[#000000]'>
                        {requestItem?.additionalInfo?.powerRestorationAt
                          ? dayjs(requestItem?.additionalInfo?.powerRestorationAt).format('DD/MM/YYYY HH:mm')
                          : ''}
                      </Typography.Text>
                    
                    
                  )}
                </div>
              </div>
            </div>
          </div>

          
        </div>
      )}
      {location.includes('request-form') &&(
        <Divider className='mt-[20px] bg-[#D4D8DE]' />
      )}
      <div className='flex items-center space-x-3'>
        <img src={progressIcon} alt='' />
        <Typography.Text className='text-[18px]/[22px] font-semibold text-[#141414]'>
          {requestform.processingTitle}
        </Typography.Text>
      </div>
      {!isHistory && (
            <>
              {requestItem?.status.code !== 'HOANTAT' && requestItem?.serviceType?.code === 'baoMatDien' && location.includes('request-form') && (
                <Checkbox className='mt-3' onChange={(e) => handlePowerRestoreChange(e.target.checked)}>
                  <Typography.Text className='text-[16px]/[16px] text-[#000000]'>
                    {requestform.isPowerRestore}
                  </Typography.Text>
                </Checkbox>
              )}
            </>
      )}
      

      {/*Assign Employee */}
      {/* {(requestItem?.status.code !== 'CHOTIEPNHAN' &&
        requestItem?.status.code !== 'HOANTAT' &&
        location.includes('request-form')) ||
        location.includes('transfer-') ? (
        <div className='flex w-full items-center space-x-3 py-5'>
          <div className='w-1/5'>
            <Typography.Text className='text-[16px]/[16px] text-[#6C737E]'>{requestform.employee}</Typography.Text>
          </div>

          <Select
            className='w-full'
            defaultValue={0}
            style={{ width: 200 }}
            onChange={(value) => setAssignUserInUnit && setAssignUserInUnit(value)}
            options={[
              { value: 0, label: 'Chọn nhân viên' },
              ...userInUnitList
                .filter((user) => user.userId !== profile?.userId)
                .map((user) => ({
                  value: user.userId,
                  label: user.fullName
                }))
            ]}
          />
        </div>
      ) : (
        ''
      )} */}

      {/*Power Outage and Restored*/}
      {location.includes('request-form') &&(
        <div className='flex flex-col gap-5 mt-4'>
            <div className='flex flex-row gap-5 items-center'>
              <Typography.Text className='text-[16px]/[16px] text-[#6C737E] text-nowrap'>NV hiện trường 1:</Typography.Text>
              <Select className='w-full' placeholder='Chọn nhân viên'>

              </Select>
            </div>
            <div className='flex flex-row gap-5 items-center'>
              <Typography.Text className='text-[16px]/[16px] text-[#6C737E] text-nowrap'>NV hiện trường 2:</Typography.Text>
              <Select className='w-full' placeholder='Chọn nhân viên'>

              </Select>
            </div>
        </div>   
      )}

      {/* Timeline */}
      <div className='pt-5'>
        {(requestItem?.status.code !== 'CHOTIEPNHAN' &&
          requestItem?.status.code !== 'HOANTAT' &&
          location.includes('request-form')) ||
        location.includes('transfer-') ? (
          <>
            {!isHistory && (
              <TextArea
                placeholder='Nội dung phản hồi'
                autoSize={{ minRows: 5, maxRows: 10 }}
                className='rounded-lg bg-[#F7F8F6]'
                value={processingContent}
                onChange={(e) => setProcessingContent && setProcessingContent(e.target.value)}
              />
            )}
          </>
        ) : (
          ''
        )}
        

        {Object.entries(groupedEvents).map(([batchUuid, batchEvents]) => (
          <div key={batchUuid} className='border-l pl-4 pb-6 relative mx-4'>
            {(batchEvents as TicketEventDto[]).map((event, eventIdx) => (
              <EventItem
                key={event.ticketEventId}
                event={event}
                isFirstEvent={eventIdx === 0}
              />
            ))}
          </div>
        ))}
        
        {/* {!isShowAllEvents && remainingEvents.length > 0 && (
          <div className='relative flex items-center mt-2 ml-4'>
            <AntdAvatar.Group maxCount={5}>
              {remainingEvents.map((event, index) => (
                <AntdAvatar
                  key={index}
                  src={<Avatar name={event.createdByName} size={32} />}
                  size={32}
                  className={index !== 0 ? '-ml-5' : ''}
                />
              ))}
            </AntdAvatar.Group>
            <Button type='link' className='ml-4 text-[#1564E8] p-0 shadow-none' onClick={toggleShowAll}>
              Xem tất cả lịch sử xử lý
            </Button>
          </div>
        )}
        
        {isShowAllEvents && (
          <div className='relative flex items-center mt-2 ml-4'>
            <Button type='link' className='ml-4 text-[#1564E8] p-0 shadow-none' onClick={toggleShowAll}>
              Thu gọn lịch sử xử lý
            </Button>
          </div>
        )} */}
      </div>
    </Card>
  );
};

export default NormalTicketOpenProcessing;
